import React from 'react';
import { cn } from './utils';
export function ChakraDivider({
  className
}: {
  className?: string;
}) {
  return <div className={cn('flex items-center justify-center gap-2 py-8', className)} data-id="element-176">
      <div className="w-1.5 h-1.5 rounded-full bg-chakra-root opacity-80" data-id="element-177" />
      <div className="w-1.5 h-1.5 rounded-full bg-chakra-sacral opacity-80" data-id="element-178" />
      <div className="w-1.5 h-1.5 rounded-full bg-chakra-solar opacity-80" data-id="element-179" />
      <div className="w-1.5 h-1.5 rounded-full bg-chakra-heart opacity-80" data-id="element-180" />
      <div className="w-1.5 h-1.5 rounded-full bg-chakra-throat opacity-80" data-id="element-181" />
      <div className="w-1.5 h-1.5 rounded-full bg-chakra-thirdEye opacity-80" data-id="element-182" />
      <div className="w-1.5 h-1.5 rounded-full bg-chakra-crown opacity-80" data-id="element-183" />
    </div>;
}